import React from "react";
import { Form, FloatingLabel } from "react-bootstrap";

const WORKFLOW_STATUS_OPTIONS = [
  { value: "working", label: "Working" },
  { value: "ready_to_review", label: "Ready to Review" },
];

const StatusDropdown = ({
  value = "",
  onSelect,
  disabled = false,
  isTransitioning = false,
  transitionType = "",
}) => {
  const handleChange = (event) => {
    const nextStatus = event.target.value;
    if (!nextStatus || nextStatus === value) return;
    onSelect?.(nextStatus);
  };

  const isUpdatingWorkflow = WORKFLOW_STATUS_OPTIONS.some(
    (option) => option.value === transitionType
  );

  const label = isTransitioning && isUpdatingWorkflow ? "Updating..." : "Update status";
  const ariaLabel = "Update program status";

  return (
    <div className="floating-label-dropdown-wrapper">
      <span className="floating-label-dropdown-title">Update status</span>

      <Form.Select
        className="input-field invoice-status-dropdown w-100"
        value={value}
        disabled={disabled || isTransitioning}
        onChange={handleChange}
      >
        <option value="">Select status...</option>
        {WORKFLOW_STATUS_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Select>
    </div>
  );
};

export default StatusDropdown;
